import { getConfig } from '@/app/config'
import { Language, User } from '@/features/auth'
import { InitialData } from '@/features/auth/domain/initial'

import { info } from '../logger'

export class UserlaneService {
  private appId: string
  private isInitialized: boolean

  get isUserlaneActive(): boolean {
    return !!window.Userlane && this.isInitialized
  }

  constructor(appId: string) {
    this.appId = appId
    this.isInitialized = false
  }

  init(user: User, initialData: InitialData, loggedInAsCustomer: boolean) {
    if (!window.Userlane) return

    const { customer, shipmentMetadata } = initialData

    const { Userlane } = window

    const isProduction = window.config.APP_ENV === 'production'
    const userlaneUserId = isProduction ? user._id : `${window.config.APP_ENV}-${user._id}`

    const userData = {
      segment: customer.segment,
      opsLoggedInAsUser: loggedInAsCustomer,
      shipmentsBookedByUser: shipmentMetadata.bookedByUser,
      shipmentsUserIsSubscribedTo: shipmentMetadata.visibleForUser,
    }

    info('User is authenticated, initializing Userlane')

    try {
      Userlane('identify', userlaneUserId, userData)
      Userlane('lang', user.preferredLanguage)
      Userlane('init', this.appId)

      this.isInitialized = true
    } catch (e) {
      info('Userlane is not initialized', e)
    }
  }

  start() {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('start', this.appId)
  }

  changeLanguage(language: Language) {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('lang', language)
    Userlane('init', this.appId)
  }

  hide() {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('hide')
  }
}

export const userlane = new UserlaneService(getConfig().USERLANE_ID ?? '')
